var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('el-form-item', { attrs: { "label": "应用范围", "prop": "plan_scope" } }, [_c('el-radio-group', { model: { value: _vm.formValue.plan_scope, callback: function callback($$v) {
        _vm.$set(_vm.formValue, "plan_scope", $$v);
      }, expression: "formValue.plan_scope" } }, _vm._l(_vm.options, function (item) {
    return _c('el-radio', { key: item.value, attrs: { "disabled": _vm.checkDisabled(item.value), "label": item.value } }, [_vm._v(_vm._s(item.label))]);
  }), 1)], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };